import React from "react";
import { Eye, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function ImpersonationBanner() {
  const { impersonating, stopImpersonation } = useAuth();
  if (!impersonating) return null;
  return (
    <div data-testid="impersonation-banner" className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 bg-[#B45309] px-4 py-2.5 text-sm font-medium text-white">
      <Eye className="h-4 w-4 shrink-0" />
      <span>You are currently viewing PlannioLife as <strong>{impersonating}</strong></span>
      <button data-testid="return-to-admin-btn" onClick={stopImpersonation} className="ml-1 flex items-center gap-1.5 rounded-lg bg-white/20 px-3 py-1 text-xs font-semibold hover:bg-white/30">
        <ArrowLeft className="h-3.5 w-3.5" /> Return to Admin Console
      </button>
    </div>
  );
}
